// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jf_a bhh_a bhh_j bhh_q bhh_st bhh_su bhh_w"};